import {
  GetKEKOfferPayments,
  GetKEKOfferPaymentsVariables,
} from "_graphql/kek/queries/__generated__/GetKEKOfferPayments";
import {
  GetOfferPayment,
  GetOfferPaymentVariables,
} from "_graphql/queries/__generated__/GetOfferPayment";

import { Offer, OfferVariables } from "_graphql/queries/__generated__/Offer";
import {
  OfferparticipantDeductions,
  OfferparticipantDeductionsVariables,
} from "_graphql/queries/__generated__/OfferparticipantDeductions";
import {
  getInsurerOfferDeductions,
  getPayment,
  getPayments,
} from "_graphql/visal/queries/payments";

import { getKEKPayments } from "_graphql/kek/queries/offers.kek";
import { getOffer } from "_graphql/visal/queries/offers";
import { useQuery } from "@apollo/client";
import {
  GetOfferPayments,
  GetOfferPaymentsVariables,
} from "_graphql/visal/queries/__generated__/GetOfferPayments";

export const useOfferPayments = (variables: GetOfferPaymentsVariables) => {
  const { data, ...rest } = useQuery<
    GetOfferPayments,
    GetOfferPaymentsVariables
  >(getPayments, {
    variables,
    notifyOnNetworkStatusChange: true,
    fetchPolicy: "network-only",
  });
  const payments = data?.getOfferPayments || [];
  return { payments, ...rest };
};

export const useKEKOfferPayments = (
  variables: GetKEKOfferPaymentsVariables
) => {
  const { data, ...rest } = useQuery<
    GetKEKOfferPayments,
    GetKEKOfferPaymentsVariables
  >(getKEKPayments, {
    variables,
    notifyOnNetworkStatusChange: true,
    fetchPolicy: "network-only",
  });
  const payments = data?.getOfferPayments || [];
  return { payments, ...rest };
};
export const useOfferPayment = (variables: GetOfferPaymentVariables) => {
  const { data, ...rest } = useQuery<GetOfferPayment, GetOfferPaymentVariables>(
    getPayment,
    {
      variables,
      notifyOnNetworkStatusChange: true,
      fetchPolicy: "network-only",
    }
  );
  const payment = data?.getOfferPayment;
  return { payment, ...rest };
};
export const useOfferParticipantDeductions = (
  variables: OfferparticipantDeductionsVariables,
  onComplete?: (data: OfferparticipantDeductions) => void
) => {
  const { data, ...rest } = useQuery<
    OfferparticipantDeductions,
    OfferparticipantDeductionsVariables
  >(getInsurerOfferDeductions, {
    variables,
    notifyOnNetworkStatusChange: true,
    fetchPolicy: "cache-first",
    onCompleted(data) {
      onComplete?.(data);
    },
  });
  const deductions =
    JSON.parse(data?.getOfferparticipantDeductions || "[]") || [];
  return { deductions, ...rest };
};

export const useOffer = (variables: OfferVariables) => {
  const { data, ...rest } = useQuery<Offer, OfferVariables>(getOffer, {
    variables,
    notifyOnNetworkStatusChange: true,
    fetchPolicy: "network-only",
  });
  return {
    offer: data?.findSingleOffer,
    ...rest,
  };
};
